import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FooterSection from "../components/sections/FooterSection";
import "./TermsPage.css";

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const items = [
    "By using InstaSnap Photobooth services or accessing our platform, you agree to these terms.",
    "We are committed to offering a smooth and enjoyable photo experience.",
    "While we strive for perfection, minor technical delays or disruptions may occasionally occur. We appreciate your patience in such cases.",
    "Your use of our services indicates your acceptance of our guidelines for safety, behavior, and privacy.",
    "Any intentional misuse or damage to our equipment may result in denied access or other consequences.",
    "We may collaborate with influencers, creators, or promotional partners. Their content reflects their own views, and we are not responsible for third-party promotions.",
    "You may not link to our website or use our content for commercial purposes without written consent.",
    "The photobooth must not be used to create inappropriate, offensive, or illegal content. We reserve the right to refuse service to anyone who violates this policy.",
    "All users are responsible for their own behavior while using the booth.",
    "InstaSnap Photobooth is not liable for any personal injury, loss, or damage that occurs during use.",
    "Each session has a time limit, so please be mindful of other users.",
  ];

  return (
    <div className="terms_page">
      <header className="terms_page_header">
        <Link
          to="/"
          className="terms_logo_link"
          onClick={() => window.scrollTo(0, 0)}
        >
          <span className="terms_logo_insta">Insta</span>
          <span className="terms_logo_snap">Snap</span>
        </Link>
      </header>
      <div className="terms_page_content">
        <h1 className="terms_page_title">Terms & Conditions</h1>
        <ul className="terms_page_list">
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
      <FooterSection />
    </div>
  );
};

export default TermsPage;
